export interface GoogleAnalyticsErrorEventType {
  event: string;
  company: string;
  appName: string;
  browserAgent: string;
  url: string;
  message: string;
}

/**
 * Values that the `event` property can take in the dataLayer for error events.
 */
export enum DataLayerErrorEventType {
  error = 'error',
  errorForm = 'error_form',
}
